export const translations = {
  en: {
    heading: 'Terms & Conditions',
  },
  ge: {
    heading: 'Allgemeine Geschäftsbedingungen',
  },
};
